module.exports = __webpack_public_path__ + "img/UserPersonalCards.6632275e.svg";